<template lang="pug">
.file-uploader.w-100
  .file-uploader__header.d-flex.justify-content-between.mb-2(v-show="title")
    .title {{title}}
    button.btn.btn-dark(@click="addEmptyFile") 新增檔案
  .input-group.mb-3.flex-nowrap(v-for="(file, i) in files" :key="i")
    .input-group-prepend
      .input-group-text 檔案 {{i+1}}
    input.form-control(v-if="!file.id" type="file" :id="`file${i+1}`" @change="onUpload(file, i, $event)")
    template(v-else)
      .input-group-append
        .input-group-text.bg-light.text-primary(
          :class="{'file-removed': removeFileIds.includes(file.id)}"
          @click="downloadFile(file)"
        ) {{file.name}}
    .input-group-append
      button.input-group-text.btn(@click="toggleRemoveFile(file, i)") 刪除
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    files: {
      type: Array,
      default: () => []
    },
    removeFileIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:files', 'update:removeFileIds'],
  computed: {
    filesValue: {
      get () { return this.files },
      set (nv) {
        this.$emit('update:files', nv)
      }
    },
    removeFileIdsValue :{
      get () { return this.removeFileIds },
      set (nv) {
        this.$emit('update:removeFileIds', nv)
      }
    }
  },

  methods: {
    onUpload (file, index, event) {
      const { files } = event.target
      const filesValue = this.files
      filesValue[index].file = files[0]
      this.filesValue = filesValue
    },
    toggleRemoveFile (file, index) {
      const { id } = file
      if (!id) {
        const filesValue = this.files
        filesValue.splice(index, 1)
        this.filesValue = filesValue
        return
      }
      const removeIdsValue = [...this.removeFileIdsValue]
      if (removeIdsValue.includes(id)) {
        this.removeFileIdsValue = removeIdsValue.filter(e => e !== id)
        return
      }
      removeIdsValue.push(id)
      this.removeFileIdsValue = [...new Set(removeIdsValue)]

    },
    async addEmptyFile () {
      const filesValue = this.files
      // for( let i = 0; i <5; i++){
        filesValue.push({ file: null, src: null })
      // }

      this.filesValue = filesValue
    },
    downloadFile (file) {
      if (!file.src) {
        return
      }
      const link = document.createElement('a')
      link.href = file.src
      link.target = '_blank'
      link.click()
    },

  },
  mounted (){

      this.addEmptyFile()

      console.log("add a new row");
    },
}
</script>

<style lang="sass" scoped>
.file-removed
  text-decoration: line-through
</style>



// WEBPACK FOOTER //
// src/views/Artedu1872/components/UploadData/FileUploader.vue